
import React from 'react';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { IconButton } from '@mui/material';

// import { Container } from './styles';

function HeaderBody({title, icon, setShow, children}) {
  return (
    <div style={{display: "flex", justifyContent: 'space-between', alignContent: 'center'}}>
        <IconButton variant="contained" 
        size="small" 
        style={{backgroundColor: 'var(--main-bg-color)', borderRadius: 25}}  
        aria-label="Notificações" 
        onClick={() => setShow(false)}>
            <ArrowBackIcon sx={{ color: "var(--main-white-color)"}} />
        </IconButton>
        <div style={{display: "flex", alignItems: 'center', height: 35, marginLeft: 20}}>
            {title}
        </div>
        {icon ? (
          <img
          src={icon}
          height="35"
          className="d-inline-block align-top"
          alt="Icone"
          style={{height: 35}}
          />
        ) : (
          <div>{children}</div>
        )}
          
    </div>
  );
}

export default HeaderBody;